/**
 * Explanner Service Documentation
 * Explanner Service Documentation
 *
 * The version of the OpenAPI document: 1.7_landesstelle{20240611@153537}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Resize200ResponseLanguage { 
    language?: string;
    displayName?: string;
    country?: string;
    variant?: string;
    script?: string;
    unicodeLocaleAttributes?: Set<string>;
    unicodeLocaleKeys?: Set<string>;
    displayLanguage?: string;
    displayScript?: string;
    displayCountry?: string;
    displayVariant?: string;
    extensionKeys?: Set<string>;
    iso3Language?: string;
    iso3Country?: string;
}

